<template>
  <div class="statu-config">
    <group v-for="(config, index) in statuConfigs" :key="index" :title="config.title" class="title">
      <cell>
        <div slot="after-title">
          <flexbox class="flexbox" v-for="(item, i) in config.items" :key="i">
            <flexbox-item :span="180/690" class="key">{{ item.name }}</flexbox-item>
            <flexbox-item class="value">{{ getValue(item) }}
              <span v-html="item.unit" v-if="item.unit"></span>
            </flexbox-item>
          </flexbox>
        </div>
      </cell>
    </group>
    <group title="备注信息" class="title" v-if="info.hasOwnProperty('remark')">
      <cell>
        <div slot="after-title" class="remark">
          {{info.remark || '无'}}
        </div>
      </cell>
    </group>
    <group title="凭证照片（如合同、收款信息、买家身份证等）" class="title image_group" v-if="!hidePic && info.hasOwnProperty('images')">
      <cell>
        <div slot="after-title">
          <div v-for="(v, i) in info.images" :key="i">
            <p class="image_name" v-if="v.name">{{v.name}}</p>
            <img :src="v.src" class="item_img" @click="clickListItem(i)">
          </div>
          <p v-if="info.images.length === 0" class="remark">无</p>
        </div>
      </cell>
    </group>
  </div>
</template>
<script>
// 零售
import {
  Cell,
  Group,
  Flexbox,
  FlexboxItem
} from '@lx-frontend/cvux'

const retails = [{
  title: '零售情况',
  items: [{
    name: '销售人员',
    field: 'employee_name'
  }, {
    name: '成交日期',
    field: 'transaction_date'
  }, {
    name: '零售成交价格',
    field: 'deal_price',
    unit: `元<span class="hint">（不含水平业务收入）</span>`
  }, {
    name: '零售收入',
    field: 'retail_income',
    unit: `元<span class="hint">（含水平业务收入）</span>`
  }, {
    name: '零售综合毛利',
    field: 'retail_gross_profit',
    unit: '元'
  }]
}, {
  title: '收车成本',
  items: [{
    name: '收车合同价',
    field: 'car_cost',
    unit: '元'
  }]
}, {
  title: '成本费用',
  items: [{
    name: '整备费用',
    field: 'maintenance_cost',
    unit: '元'
  }, {
    name: '过户费',
    field: 'transfer_fee',
    unit: '元'
  }, {
    name: '其它费用',
    field: 'other_cost',
    unit: '元'
  }, {
    name: '成本费用合计',
    field: 'all_cost',
    unit: '元'
  }]
}, {
  title: '水平业务收益',
  items: [{
    name: '水平总收入',
    field: 'car_income',
    unit: '元'
  }, {
    name: '水平总成本',
    field: 'car_gross_profit',
    unit: '元'
  }, {
    name: '水平总毛利',
    field: 'car_gross_all',
    unit: '元'
  }]
}, {
  title: '客户信息',
  items: [{
    name: '买家姓名',
    field: 'buyer_name'
  }, {
    name: '买家电话',
    field: 'buyer_mobile'
  }]
}]
// 批售
const batchsales = [{
  title: '客户信息',
  items: [{
    name: '批售对象',
    field: 'dealer_type'
  }, {
    name: '名称',
    field: 'dealer_name'
  }, {
    name: '买家姓名',
    field: 'buyer_name'
  }, {
    name: '买家电话',
    field: 'buyer_mobile'
  }]
}, {
  title: '收车成本',
  items: [{
    name: '收车合同价',
    field: 'car_cost',
    unit: '元'
  }]
}, {
  title: '批售情况',
  items: [{
    name: '成交价格',
    field: 'car_income',
    unit: '元'
  }, {
    name: '成交毛利',
    field: 'batchSales_gross_profit',
    unit: '元'
  }, {
    name: '成交日期',
    field: 'transaction_date'
  }]
}]
// 报废
const scraps = [{
  title: '报废情况',
  items: [{
    name: '成交日期',
    field: 'transaction_date'
  }, {
    name: '车辆成本',
    field: 'car_cost',
    unit: '元'
  }, {
    name: '车辆收入',
    field: 'car_income',
    unit: '元'
  }, {
    name: '车辆毛利',
    field: 'out_gross_profit',
    unit: '元'
  }]
}]

// 特殊
const special = [{
  title: '特殊出库情况',
  items: [{
    name: '出库日期',
    field: 'transaction_date'
  }, {
    name: '综合收入',
    field: 'car_income',
    unit: '元'
  }, {
    name: '综合成本',
    field: 'car_cost',
    unit: '元'
  }, {
    name: '综合毛利',
    field: 'out_gross_profit',
    unit: '元'
  }]
}, {
  title: '客户信息',
  items: [{
    name: '买家姓名',
    field: 'buyer_name'
  }, {
    name: '买家电话',
    field: 'buyer_mobile'
  }]
}]

export default {
  components: {
    Cell,
    Group,
    Flexbox,
    FlexboxItem
  },
  props: {
    hidePic: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    clickListItem(item) {
      this.$emit('click-swiper', item)
    },
    getValue (item) {
      let text = ''
      let value = this.info[item.field]
      if (/元/g.test(item.unit)) {
        switch (item.field) {
          case 'retail_income': // 零售收入
            text = this.info.deal_price + this.info.car_income
            break
          case 'retail_gross_profit': // 零售综合毛利
            text = this.info.deal_price + this.info.car_income - this.info.car_gross_profit - this.info.car_cost - this.info.maintenance_cost - this.info.transfer_fee - this.info.other_cost
            break
          case 'all_cost': // 零售成本费用合计
            text = this.info.maintenance_cost + this.info.transfer_fee + this.info.other_cost
            break
          case 'car_gross_all': // 零售水平总成本
            text = this.info.car_income - this.info.car_gross_profit
            break
          case 'batchSales_gross_profit': // 批售成交毛利
            text = this.info.car_income - this.info.car_cost
            break
          case 'out_gross_profit': // 报废和特殊出库车辆毛利
            text = this.info.car_income - this.info.car_cost
            break
          default:
            text = value
            break
        }
        text = (text / 100).toFixed(2)
      } else if (item.field === 'dealer_type') {
        let batchInfo = {
          other: '其他平台',
          non_lixin: '非立新车市车商',
          lixin: '立新车市的有效车商'
        }
        text = batchInfo[value] || '--'
      } else {
        text = value
      }
      return text
    }
  },
  computed: {
    statuConfigs () {
      let configs = []
      switch (this.type) {
        case 'retail':
          configs = retails
          break
        case 'batch_sale':
          configs = batchsales
          break
        case 'scrap':
          configs = scraps
          break
        case 'special':
          configs = special
          break
        default:
          configs = []
          break
      }
      return configs
    }
  }
}

</script>

<style lang="less">
@import "../../../stylesheets/modules/manage/order.less";
.statu-config {
  margin-top: 20/@w2;
  .title {
    background-color: #fff;
    // .weui_cells_title {
    //   padding-top: 0;
    // }
    .weui_cell {
      padding-bottom: 0;
      &:first-child {
        &:before {
          display: block;
        }
      }
    }
    .hint, .remark {
      color: #9a9a9a;
      font-size: 26/@w2;
    }
    .item_img {
      display: block;
      width: 100%;
    }
  }
  .weui_cells {
    &:before {
      border: 0;
    }
    &:after {
      border-bottom: 0;
    }
  }
  .image_name{
    color: #000;
    opacity: 0.7;
    font-size: 26/@w2;
    line-height:58/@w2;
    padding-top: 30/@w2;
  }
  .image_group{
    padding-bottom: 30/@w2;
    .weui_cell{padding: 0 30/@w2;}
  }
}
</style>
